/**
 * Helper methods for loading/injecting scripts programmatically.
 */

export class ScriptLoader {
	/**
	 * Loads/Injects a script from a source.
	 * @param src The source of the script, usually a URL.
	 * @param attributes Arbitrary attributes that are set on the script tag.
	 */
	public static LoadScript(src: string, attributes?: Record<string, string>): void {
		const script = document.createElement("script");
		script.src = src;
		script.type = "text/javascript";

		if (attributes != null) {
			for (const [key, value] of Object.entries(attributes)) {
				const attribute = document.createAttribute(key);
				attribute.value = value;
				script.attributes.setNamedItem(attribute);
			}
		}
		document.body.appendChild(script);
	}
}
